import { action, makeAutoObservable, observable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import unitService from "@services/projects/unitService"
import fileService from "@services/common/fileService"
import { moduleNames } from "@lib/appconst"

class UnitStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable listUnit!: any
  @observable auditLogData!: any
  @observable listUnitPricing!: any

  @observable listUnitByInquiry!: PagedResultDto<any>

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
    this.isLoading = false
    this.listUnit = []
    this.auditLogData = []
    this.listUnitPricing = []
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    if (!body.id) {
      const result = await unitService.create(body)
      this.detailData = result
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService.upload(moduleNames.unit, uniqueId, fileUpload)
          }
        })
      }
    } else {
      const result = await unitService
        .updateDetail(body)
        .catch(() => (this.isLoading = false))

      this.detailData = result
      this.isLoading = false
      const { uniqueId } = result
      if (files && files.length && uniqueId) {
        files.forEach(async (file) => {
          if (file.originFileObj !== undefined) {
            const fileUpload = file.originFileObj
            await fileService.upload(moduleNames.unit, uniqueId, fileUpload)
          }
        })
      }
    }
  }

  @action
  async emptyDetail() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async delete(id: number) {
    await unitService.delete(id)
    this.tableData.items = this.tableData.items.filter((x) => x.id !== id)
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await unitService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id: number) {
    this.isLoading = true
    const result = await unitService
      .get(id)
      .finally(() => (this.isLoading = false))

    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await unitService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
    return result.items
  }
  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await unitService
      .getList(params)
      .finally(() => (this.isLoading = false))
    this.listUnit = result
    return result
  }
  async getAllUnitMatchingInquiry(params: any) {
    this.isLoading = true
    const result = await unitService
      .getAllUnitMatchingInquiry(params)
      .finally(() => (this.isLoading = false))
    this.listUnitByInquiry = result
    return result.items
  }

  async getListReadyForHandover(params: any) {
    this.isLoading = true
    const result = await unitService
      .getListReadyForHandover(params)
      .finally(() => (this.isLoading = false))
    return result
  }
  @action
  async exportExcel(params: any) {
    this.isLoading = true
    return await unitService
      .exportExcel(params)
      .finally(() => (this.isLoading = false))
  }
  @action
  async getAuditLog(id: any) {
    this.isLoading = true
    const result = await unitService
      .getAuditLog(id)
      .finally(() => (this.isLoading = false))

    this.auditLogData = result
  }
  @action
  async getListUnitPricingHistory(params: any) {
    this.isLoading = true
    const result = await unitService
      .getListUnitPricingHistory(params)
      .finally(() => (this.isLoading = false))

    this.listUnitPricing = result
  }
}

export default UnitStore
